module.exports = __webpack_public_path__ + "static/img/bg2.042df5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg2.png
// module id = Oi//
// module chunks = 1